import { createSlice } from "@reduxjs/toolkit";

import { ReduxStateType } from "redux-store/types";

interface InitialState {
  status: ReduxStateType;
}

const initialState: InitialState = {
  status: ReduxStateType.ERROR,
};

const exportTimeKeepingMonthSlice = createSlice({
  name: "exportTimeKeepingMonth",
  initialState,
  reducers: {
    exportTimeKeepingMonthStart: (state, action) => {
      state.status = ReduxStateType.LOADING;
    },
    exportTimeKeepingMonthSuccess: (state) => {
      state.status = ReduxStateType.SUCCESS;
    },
    exportTimeKeepingMonthFailed: (state) => {
      state.status = ReduxStateType.ERROR;
    },
  },
});

export const {
  exportTimeKeepingMonthStart,
  exportTimeKeepingMonthSuccess,
  exportTimeKeepingMonthFailed,
} = exportTimeKeepingMonthSlice.actions;

export default exportTimeKeepingMonthSlice.reducer;
